<template>
  <div class="defaultTextUnitCustom">
		<el-link
			:type="tableData.style || 'primary'"
			:underline="false"
			:disabled="tableData.disabled && tableData.disabled(scope, tableData)"
			>{{ tableData.click ? tableData.click(scope) : scope.row[tableData.bind] }}</el-link
		>
	</div>
</template>
<script>
export default {
  name: "defaultTextUnitCustom",
  props: ["tableData", "scope"],
  data() {
    return {};
  },
  mounted() {}
};
</script>
<style lang="scss">
.defaultTextUnitCustom {
  .el-link {
    width: 100%;
    .el-link--inner {
      color: #606266;
      font-size: 14px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-right: auto;
    }
  }
}
</style>